<template>
  <span
    class="moderated-operation-state"
    :class="`moderated-operation-state--${display}`"
    :style="{
      '--moderated-operation-state-color': stepperColor,
      '--moderated-operation-state-bg': stepperBgColor,
      '--moderated-operation-state-border': stepperBorderColor
    }"
  >
    <span
      v-if="showStepper"
      class="moderated-operation-state__stepper"
      aria-hidden="true"
    >
      <span
        v-for="segment in totalSegments"
        :key="segment"
        class="moderated-operation-state__segment"
        :class="{
          'moderated-operation-state__segment--active':
            segment <= progressValue
        }"
      ></span>
    </span>
    <span
      v-if="showText"
      class="moderated-operation-state__text"
      :style="{ color: textColor }"
    >
      {{ label }}
    </span>
  </span>
</template>

<script>
import investigatorTablesMethods from "../../mixins/investigatorTablesMethods";

export default {
  name: "ModeratedOperationState",
  mixins: [investigatorTablesMethods],
  props: {
    state: {
      type: String,
      required: true
    },
    finished: {
      type: Boolean,
      default: false
    },
    authorized: {
      default: null,
      validator: value => value === null || typeof value === "boolean"
    },
    formName: {
      type: String,
      default: ""
    },
    display: {
      type: String,
      default: "stepper-text",
      validator: value => ["stepper", "stepper-text", "text"].includes(value)
    },
    textVariant: {
      type: String,
      default: "state",
      validator: value => ["state", "userfriendly"].includes(value)
    }
  },
  computed: {
    totalSegments() {
      return 4;
    },
    showStepper() {
      return this.display === "stepper" || this.display === "stepper-text";
    },
    showText() {
      return this.display === "text" || this.display === "stepper-text";
    },
    label() {
      return this.getModeratedOperationText(
        this.state,
        this.finished,
        this.textVariant
      );
    },
    progressValue() {
      return this.getModeratedOperationProgressValue(this.state, this.finished);
    },
    stepperColor() {
      return this.getModeratedOperationVisualColor(
        this.state,
        this.finished,
        this.authorized
      );
    },
    stepperBgColor() {
      return this.getModeratedOperationVisualBgColor(
        this.state,
        this.finished,
        this.authorized
      );
    },
    stepperBorderColor() {
      return this.getModeratedOperationVisualBorderColor(
        this.state,
        this.finished,
        this.authorized
      );
    },
    textColor() {
      return this.stepperColor;
    }
  }
};
</script>

<style scoped>
.moderated-operation-state {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  white-space: nowrap;
  vertical-align: middle;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid var(--moderated-operation-state-border);
  background-color: var(--moderated-operation-state-bg);
}

.moderated-operation-state__stepper {
  display: inline-flex;
  align-items: center;
  gap: 3px;
}

.moderated-operation-state__segment {
  width: 11px;
  height: 6px;
  border-radius: 999px;
  background-color: rgba(0, 0, 0, 0.14);
}

.moderated-operation-state__segment--active {
  background-color: var(--moderated-operation-state-color);
}

.moderated-operation-state__text {
  line-height: 1.1;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.045em;
  text-transform: uppercase;
}

.moderated-operation-state--stepper .moderated-operation-state__stepper {
  gap: 4px;
}

.moderated-operation-state--text {
  padding-left: 9px;
  padding-right: 9px;
}
</style>
